import {saveRequest, removeRequest, FilemanagerApi} from '@requests';
import {v4 as uuid} from 'uuid';
import {
    loadingApplication,
    addNotification,
    resendZajavlsIfExistsNotification,
} from '@componentDP/js_react/redux/actions/application';
import {getDocuments, getDocumentsRepeat} from '@services';
import {collectFileIdsFromDocuments, postProcessingFileSave, preProcessingFilesSave} from '@services/filemanager';
import {isEmpty} from 'lodash';
import {filesInfoReceived} from '@componentDP/js_react/redux/actions/files';
import {store} from '../store/index';
import {
    EGE_DOCUMENTS,
    TYPES_EGE_DOCUMENTS,
    SCHEMES_EGE_DOCUMENTS,
    LOADING_EGE_DOCUMENTS,
    LOADED_EGE_DOCUMENTS,
} from '../store/actionTypes';

export function initializationEgeDocuments() {
    return async (dispatch) => {
        const {loadedEgeDocuments, apiDomainFilemanager} = store.getState();
        dispatch(setLoadingEgeDocuments(true));
        let fileIds = [];
        if (!loadedEgeDocuments) {
            const [types, schemes, documentsPrepare] = await getDocuments(5);
            dispatch(setTypesEgeDocuments(types));
            dispatch(setSchemesEgeDocuments(schemes));
            dispatch(setEgeDocuments(documentsPrepare));
            dispatch(setLoadedEgeDocuments(true));
            fileIds = collectFileIdsFromDocuments(documentsPrepare);
        } else {
            dispatch(setLoadingEgeDocuments(true));
            const documentsPrepare = await getDocumentsRepeat(5);
            dispatch(setEgeDocuments(documentsPrepare));
            fileIds = collectFileIdsFromDocuments(documentsPrepare);
        }
        if (!isEmpty(fileIds)) {
            const filemanagerApi = new FilemanagerApi(apiDomainFilemanager);
            const result = await filemanagerApi.getFilesInfo(fileIds);
            dispatch(filesInfoReceived(result));
        }
        dispatch(setLoadingEgeDocuments(false));
    };
}
export function addEgeDocument() {
    return (dispatch) => {
        const {egeDocuments} = store.getState();
        dispatch(setEgeDocuments([...egeDocuments, {uuid: uuid()}]));
    };
}
export function removeEgeDocument(uuid, t) {
    return async (dispatch, getState) => {
        try {
            dispatch(loadingApplication(true));
            const {apiDomainVikon, egeDocuments} = getState();
            const filteredDocuments = [];
            for (const document of egeDocuments) {
                if (document.uuid !== uuid) {
                    filteredDocuments.push(document);
                } else if (document.doc_id) {
                    const removedResult = await removeRequest(
                        `${apiDomainVikon}api/digital_profile/applicant/documents`,
                        document.doc_id,
                    );
                    if (!removedResult) {
                        throw new Error(t('failed_to_delete'));
                    }
                }
            }

            dispatch(setEgeDocuments(filteredDocuments));
            dispatch(addNotification({message: t('deleted'), type: 'success'}));
            dispatch(resendZajavlsIfExistsNotification());
        } catch (e) {
            dispatch(addNotification({message: e.message, type: 'error'}));
        } finally {
            dispatch(loadingApplication(false));
        }
    };
}
export function saveEgeDocuments(dataList, t) {
    return async (dispatch) => {
        dispatch(loadingApplication(true));
        const {apiDomainVikon, apiDomainFilemanager} = store.getState();
        let errors = '';
        const savedEgeDocuments = [];
        for (const data of dataList) {
            const [idsForSave, idsForDelete, afterSuccessSaveCallback] = preProcessingFilesSave(data);
            const savedEgeDocument = await saveRequest(
                `${apiDomainVikon}api/digital_profile/applicant/documents${data.id ? `/${data.id}` : ''}`,
                data,
            );
            if (!savedEgeDocument.errors) {
                savedEgeDocument.uuid = data.uuid;
                savedEgeDocuments.push(savedEgeDocument);
                await postProcessingFileSave(idsForSave, idsForDelete, afterSuccessSaveCallback, apiDomainFilemanager);
            } else {
                errors += savedEgeDocument.errors;
            }
        }
        if (!errors.length) {
            dispatch(setEgeDocuments(savedEgeDocuments));
            dispatch(addNotification({message: t('saved'), type: 'success'}));
            dispatch(resendZajavlsIfExistsNotification());
        } else {
            dispatch(addNotification({message: errors, type: 'error'}));
        }
        dispatch(loadingApplication(false));
    };
}
export function unmountEgeDocuments() {
    return (dispatch) => {
        dispatch(setEgeDocuments([]));
    };
}
export function setTypesEgeDocuments(list) {
    return {
        type: TYPES_EGE_DOCUMENTS,
        list,
    };
}
export function setEgeDocuments(list) {
    return {
        type: EGE_DOCUMENTS,
        list,
    };
}
export function setLoadingEgeDocuments(status) {
    return {
        type: LOADING_EGE_DOCUMENTS,
        status,
    };
}
export function setLoadedEgeDocuments(status) {
    return {
        type: LOADED_EGE_DOCUMENTS,
        status,
    };
}
export function setSchemesEgeDocuments(object) {
    return {
        type: SCHEMES_EGE_DOCUMENTS,
        object,
    };
}
